// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"105":"cart-handler","172":"list-handler"}[chunkId] + "." + {"105":"63a029a8","172":"6b8cc8dc"}[chunkId] + ".js";
};